import React, { Component } from 'react';
import { Badge, Button, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row } from 'reactstrap';
import axios from "axios";
import {appConfig} from "./../tools/AppConfig";
import Waiting from './../modules/waiting';
import Message from './errors/message';
import SimpleHeader from './../modules/simpleHeader_new';
import Card from './../modules/paymentMethods/card';
import Installments from '../modules/paymentMethods/installments';
import Wallet from './../modules/paymentMethods/wallet';
import Cash from './../modules/paymentMethods/cash';
import Aman from './../modules/paymentMethods/aman';
import Premium from './../modules/paymentMethods/premium';
import Valu_online from './../modules/paymentMethods/valu_invoice';
import Valu from './../modules/paymentMethods/valu';
import Sympl from './../modules/paymentMethods/sympl';
import Jawwal from './../modules/paymentMethods/Jawwal';
import Forsa from './../modules/paymentMethods/Forsa';
import Delivery from './../modules/paymentMethods/delivery_new';
import Souhoola from '../modules/paymentMethods/souhoola';
import amanImg from './../../statics/img/payment_methods_logos/logo_aman.png';
import masaryImg from './../../statics/img/payment_methods_logos/logo_masary.png';
import cashImg from './../../statics/img/newPayment/cash.svg';
import cardImg from './../../statics/img/newPayment/credit.svg';
import walletImg from './../../statics/img/newPayment/wallet.svg';
import kioskImg from './../../statics/img/newPayment/kiosk.svg';
import premiumImg from './../../statics/img/payment_methods_logos/logo_premium.gif';
import valuImg from './../../statics/img/payment_methods_logos/ValU.png';
import symplImg from './../../statics/img/payment_methods_logos/Sympl.png';
import forsaImg from "../../statics/img/forsaLogo.png"
import souhoolaIcon from './../../statics/img/souhoola-icon.svg';
import favicon from './../../statics/img/favicon.svg';
import ConsumerDiscounts from "./../modules/iframes/paymentMethods/consumerDiscounts/ConsumerDiscounts"
import favicon_jawwal from './../../statics/img/fav_icon.png';
import SubData from './../modules/paymentMethods/sub-data_new';
import OrascomIMG from './../../statics/img/orascom.png';

// import './../custom.css';
import './../custom_new.css';
import './invoice.css';


import 'icheck/skins/all.css'; // or single skin css
import {Radio, RadioGroup} from 'react-icheck';

class invoice extends Component {
    constructor(props){
        super(props);
        this.state = {
            dataLoaded: false,
            userData: null,
            requestComplete: false,
            completeMessage: {'head': "", 'body': ""},
            currentMethod: '',
            MethodsName: {
                VPC: "Card",
                UIG: "Wallet",
                CASH: "Cash Collection",
                CAGG: "Accept Kiosk",
                PREMIUM: "Premium",
                SYMPL: "Sympl",
                VALU: "Valu",
                MPAY: "Jawwal Pay",
                installments: "Installments",
                FORSA:"FORSA",
                SOUHOOLAV2:"Souhoola"
            },
            paymentMethodsDisable: false,
            deliveryDataCollected: false,
            deliveryData: {

            },
            //acq_partner
            acq_partner: false,
            styleData: {},
            accordion: [true, false, false, false, false],
            completeSubDeliveryForm: false,
            is_orascom: false

        };
        this.renderError  = this.renderError.bind(this);
        this.renderBody = this.renderBody.bind(this);
        this.paymentsMethods = this.paymentsMethods.bind(this);
        this.renderCurrentImg = this.renderCurrentImg.bind(this);
        this.disableAllPaymentMethods = this.disableAllPaymentMethods.bind(this);
        this.enableAllPaymentMethods = this.enableAllPaymentMethods.bind(this);
        this.handleMethodChange = this.handleMethodChange.bind(this);
        this.renderPaymentMethod = this.renderPaymentMethod.bind(this);
        this.currentPaymentMethodComponent = this.currentPaymentMethodComponent.bind(this);
        this.setDeliveryData = this.setDeliveryData.bind(this);
        this.setSubDeliveryData = this.setSubDeliveryData.bind(this);
        this.setReqComplete = this.setReqComplete.bind(this);
        this.loadData();
        this.toggleAccordion = this.toggleAccordion.bind(this);
        this.renderDeliveryForm = this.renderDeliveryForm.bind(this);
        this.renderSubDeliveryForm = this.renderSubDeliveryForm.bind(this);

    }
    toggleAccordion(tab) {
        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);
    
        this.setState({
          accordion: state,
        });
    }
    check_is_orascom (integration_ids){
        let is_orascom = false;
        let integration_keys = Object.keys(integration_ids);
        let current_integration_array = [];
        let orascom_integration_array = [3869631, 3869632, 3883545, 3883557];

        for(let i=0; i< integration_keys.length;i++){
            let key = integration_keys[i];
            current_integration_array.push(integration_ids[key]);
        }

        current_integration_array.map((current_integration)=>{
            if(orascom_integration_array.includes(current_integration)){
               is_orascom = true; 
            }
        })
        return is_orascom
    }
    loadData(){
        let token = this.props.token;
        let invoiceUrl = appConfig.getServerUrl() + '/invoice2/' + token;
        let config = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        axios.get(
            invoiceUrl,
            config
        )
        .then((respond)=>{
            if(respond.data.error){
                this.setReqComplete({head: '', body: respond.data.error});
            } else {
                // Show form to complete data
                console.log(respond.data);
                let complete_var;
                if (respond.data.order_email == "N/A" || respond.data.order_full_name == "N/A N/A"){
                    complete_var =  true;
                }else{
                    complete_var =  false;
                }
                let is_orascom = this.check_is_orascom(respond.data.integration_ids);
                
                this.setState({is_orascom: is_orascom, userData: respond.data, dataLoaded: true, completeSubDeliveryForm: complete_var }, () => {
                    document.title="Paymob |" +this.state.userData.order_merchant_name;
                    let current_integrations_keys = [];
                    let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
                    for(let i=0; i< all_integ_key_arr.length;i++){
                        if(this.state.MethodsName[all_integ_key_arr[i]]){
                            current_integrations_keys.push(all_integ_key_arr[i]);
                        }
                    }
                    // this.setState({currentMethod: current_integrations_keys[0]},()=>{
                    this.setState({},()=>{
                        if(this.state.acq_partner){
                            this.setPartnerColors(this.state.styleData)
                        }else{
                            const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                            link.rel="shortcut icon"
                            link.type = 'image/x-icon'
                            link.href= favicon;
                        }
                    })
                });
            }
        })
        .catch((err)=>{
            if(this.state.acq_partner){
                this.setPartnerColors(this.state.styleData)
            }else{
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.rel="shortcut icon"
                link.type = 'image/x-icon'
                link.href= favicon;
            }
            this.setReqComplete({head: 'Connection error', body:'Oops! Something went wrong. If this problem persists, please contact your service provider.'});
        });
    }
    paymentsMethods(){
        let current_integrations_keys = [];
        let all_integ_key_arr = Object.keys(this.state.userData.integration_ids);
        for(let i=0; i< all_integ_key_arr.length;i++){
            if(this.state.MethodsName[all_integ_key_arr[i]]){
                current_integrations_keys.push(all_integ_key_arr[i]);
            }
        }
        if(this.state.userData.bank_installment && this.state.userData.bank_installment !== null){
            current_integrations_keys.push('installments');
        }
        return(
            // <RadioGroup name="radio" defaultValue={current_integrations_keys[0]} onChange = {this.handleMethodChange}>
            <RadioGroup name="radio" onChange = {this.handleMethodChange}>
                {current_integrations_keys.map((key, index) => {
                    return <Radio
                        key= {key}
                        value={key}
                        radioClass="iradio_flat-blue"
                        increaseArea="20%"
                        className="ssss"
                        label={"<span class='paymentMethodSpan'>" + this.renderCurrentImg(key) + "<span>" + this.state.MethodsName[key] + "</span></span>"}
                        disabled={this.state.paymentMethodsDisable}
                    />
                })} 
            </RadioGroup>
        );
    }
    renderCurrentImg(key){
        let allowedAggre = this.state.userData.allowed_aggregators;
        if(key === 'VPC' || key === 'installments'){
            return "<img class='paymentMethodImg' src=" + cardImg + " alt=" + key + " />"
        }else if(key === 'UIG'){
            return "<img class='paymentMethodImg' src=" + walletImg + " alt=" + key + " />"
        }else if(key === 'CASH'){
            return "<img class='paymentMethodImg' src=" + cashImg + " alt=" + key + " />"
        }else if(key === 'CAGG'){
            if(allowedAggre === "aman"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " />"
            }else if(allowedAggre === "masary"){
                return "<img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else if(allowedAggre === "aman/masary"){
                return "<img class='paymentMethodImg' src=" + amanImg + " alt=" + key + " /><img class='paymentMethodImg' src=" + masaryImg + " alt=" + key + " />"
            }else{
                return ''
            }
        }else if(key === 'PREMIUM'){
            return "<img class='paymentMethodImg' src=" + premiumImg + " alt=" + key + " />"
        }else if(key === 'VALU'){
            return "<img class='paymentMethodImg' src=" + valuImg + " alt=" + key + " />"
        }else if(key === 'SYMPL'){
            return "<img class='paymentMethodImg' src=" + symplImg + " alt=" + key + " />"
        }
        else if(key === 'FORSA'){
            return "<img class='paymentMethodImg' src=" + forsaImg + " alt=" + key + " />"
        }
        else if(key === 'SOUHOOLAV2'){
            return "<img class='paymentMethodImg' src=" + souhoolaIcon + " alt=" + key + " />"
        }
        return ''
    }
    disableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: true});
    }
    enableAllPaymentMethods(){
        this.setState({paymentMethodsDisable: false});
    }
    handleMethodChange(e){
        this.setState({currentMethod: e.target.value});
    }

    renderPaymentMethod() {
        let deliveryNeed = this.state.userData.order_delivery;
        if(deliveryNeed === false){
            return this.currentPaymentMethodComponent();
        }else if (deliveryNeed === true){
            if(this.state.deliveryDataCollected){
                return this.currentPaymentMethodComponent();
            }else{
                return <Delivery collapseButton={true} toggleAccordion={this.toggleAccordion} sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}/>
            }
        }
        
    }
    renderDeliveryForm() {
        return <Delivery collapseButton={true} toggleAccordion={this.toggleAccordion} sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}/>
    }
    renderSubDeliveryForm() {
        return <SubData collapseButton={true} toggleAccordion={this.toggleAccordion} userData={this.state.userData} setSubDeliveryData={this.setSubDeliveryData}/>
    }
    setDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}}, () => {
            if (!this.state.accordion[1]) {
                this.toggleAccordion(1)
            }
        });
    }
    setSubDeliveryData(data) {
        this.setState({deliveryDataCollected: true, deliveryData: {...data}}, () => {
            this.toggleAccordion(1)
        });
    }
    setReqComplete(Message){
        this.setState({requestComplete: true, completeMessage: Message, dataLoaded: true});
    }
    currentPaymentMethodComponent() {
        let currentMethod = this.state.currentMethod;
        let deliveryNeed = this.state.userData.order_delivery;
        if( currentMethod === 'VPC'){
            if(this.state.userData.discounts && this.state.userData.discounts.length > 0){
                if(deliveryNeed === false){
                    if (this.state.completeSubDeliveryForm === true){
                        return <ConsumerDiscounts 
                            platform="standalone" 
                            payment_token={this.state.userData.token}
                            sourcePage='invoice'
                            deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                            setReqComplete={this.setReqComplete}
                            disableAllPaymentMethods={this.disableAllPaymentMethods}
                            enableAllPaymentMethods={this.enableAllPaymentMethods}
                        />
                    }else{
                        return <ConsumerDiscounts 
                            platform="standalone" 
                            payment_token={this.state.userData.token}
                            sourcePage='invoice'
                            deliveryNeed={false} deliveryData={null} userData={this.state.userData} 
                            setReqComplete={this.setReqComplete}
                            disableAllPaymentMethods={this.disableAllPaymentMethods}
                            enableAllPaymentMethods={this.enableAllPaymentMethods}
                        />
                    }
                }else if (deliveryNeed === true){
                    return <ConsumerDiscounts 
                    platform="standalone" 
                    payment_token={this.state.userData.token}
                    sourcePage='invoice'
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }
            } else{
                if(deliveryNeed === false){
                    if (this.state.completeSubDeliveryForm === true){
                        return <Card 
                            sourcePage='invoice'
                            deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                            setReqComplete={this.setReqComplete}
                            disableAllPaymentMethods={this.disableAllPaymentMethods}
                            enableAllPaymentMethods={this.enableAllPaymentMethods}
                        />
                    }else{
                        return <Card
                            sourcePage='invoice'
                            deliveryNeed={false} deliveryData={null} userData={this.state.userData} 
                            setReqComplete={this.setReqComplete}
                            disableAllPaymentMethods={this.disableAllPaymentMethods}
                            enableAllPaymentMethods={this.enableAllPaymentMethods}
                        />
                    }
                    
                }else if (deliveryNeed === true){
                    return <Card 
                        sourcePage='invoice'
                        deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                        setReqComplete={this.setReqComplete}
                        disableAllPaymentMethods={this.disableAllPaymentMethods}
                        enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }
            }
        }else if( currentMethod === 'UIG'){
            if(deliveryNeed === false){
                return <Wallet sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete}/>
            }else if (deliveryNeed === true){
                return <Wallet sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CASH'){
            if(this.state.deliveryDataCollected){
                return <Cash sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else{
                return <Delivery sourcePage='invoice' userData={this.state.userData} setDeliveryData={this.setDeliveryData}/>
            }
            if(deliveryNeed === false){
                return <Wallet deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Wallet deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'CAGG'){
            if(deliveryNeed === false){
                return <Aman sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }else if (deliveryNeed === true){
                return <Aman sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} setReqComplete={this.setReqComplete} />
            }
        }else if( currentMethod === 'PREMIUM'){
            if(deliveryNeed === false){
                return <Premium sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Premium sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'VALU'){
            if(this.state.userData.is_valu_online){
                if(deliveryNeed === false){
                    return <Valu_online sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                        setReqComplete={this.setReqComplete}
                        disableAllPaymentMethods={this.disableAllPaymentMethods}
                        enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }else if (deliveryNeed === true){
                    return <Valu_online sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                        setReqComplete={this.setReqComplete}
                        disableAllPaymentMethods={this.disableAllPaymentMethods}
                        enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }
            }else{
                if(deliveryNeed === false){
                    return <Valu sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                        setReqComplete={this.setReqComplete}
                        disableAllPaymentMethods={this.disableAllPaymentMethods}
                        enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }else if (deliveryNeed === true){
                    return <Valu sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                        setReqComplete={this.setReqComplete}
                        disableAllPaymentMethods={this.disableAllPaymentMethods}
                        enableAllPaymentMethods={this.enableAllPaymentMethods}
                    />
                }
            }
        }else if( currentMethod === 'SYMPL'){
            if(deliveryNeed === false){
                return <Sympl sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Sympl sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if( currentMethod === 'SOUHOOLAV2'){
            if(deliveryNeed === false){
                return <Souhoola  userData={this.state.userData} deliveryNeed={false} setReqComplete={this.setReqComplete}
                deliveryData={this.state.deliveryData} type="invoice"/>
            }else if (deliveryNeed === true){
                return <Souhoola  userData={this.state.userData} deliveryNeed={true} setReqComplete={this.setReqComplete}
                deliveryData={this.state.deliveryData} type="invoice"/>
            }
        }else if( currentMethod === 'MPAY'){
            if(deliveryNeed === false){
                return <Jawwal sourcePage='invoice' deliveryNeed={false} deliveryData={null} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Jawwal sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }
        else if( currentMethod === 'FORSA'){
            if(deliveryNeed === false){
                return <Forsa sourcePage='invoice' deliveryNeed={false} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Forsa sourcePage='invoice' deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData}
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else if(currentMethod === 'installments'){
            if(deliveryNeed === false){
                return <Installments
                    sourcePage='invoice'
                    deliveryNeed={false} deliveryData={null} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }else if (deliveryNeed === true){
                return <Installments 
                    sourcePage='invoice'
                    deliveryNeed={true} deliveryData={this.state.deliveryData} userData={this.state.userData} 
                    setReqComplete={this.setReqComplete}
                    disableAllPaymentMethods={this.disableAllPaymentMethods}
                    enableAllPaymentMethods={this.enableAllPaymentMethods}
                />
            }
        }else{
            return <p>{this.state.MethodsName[this.state.currentMethod]}</p>
        }
    }
    renderError(){
        return ( 
            <div className="invoice">
                <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                <Message body={this.state.userData.errorMessage} />
            </div>
        );
    }
    renderBody(){
        let domain = window.location.hostname;
        let lang = localStorage.lang !== undefined ? localStorage.lang : "en";
        if(domain === "localhost"){
            domain = "accept-alpha.paymob.com"
        } else {
            domain = "accept.paymob.com";
        }
        let regURL = "https://" + domain + "/portal2/" + lang + "/register";
        let paymobAppURL = "https://play.google.com/store/apps/details?id=com.paymob.paymob_app";
        if(this.state.requestComplete){
            return ( 
                <div class="newStandalone">
                    <div className="invoice">
                        {this.state.is_orascom ?
                                <div className="orascom_header">
                                    <img src={OrascomIMG} alt="Orascom" />
                                </div>
                            :
                                <>
                                    <SimpleHeader acq_partner={this.state.acq_partner} acq_partner_data={this.state.styleData}/>
                                    <div className="companyDetails">
                                        {this.state.userData && this.state.userData.logo_uri ?
                                            <div className="compLogo">
                                                <img src={appConfig.getServerUrl() + this.state.userData.logo_uri} alt='CompanyLogo'/>
                                        </div>
                                            :
                                            <h1>Paymob Invoice</h1>
                                    }
                                </div>
                            </>
                        }
                        <div className="standaloneBody">
                        <Message head={this.state.completeMessage.head} body={this.state.completeMessage.body} sympl={this.state.completeMessage.sympl} sympl_data={this.state.completeMessage.sympl_data} />
                        </div>
                        <div className="startSell">
                                <p>Start selling your products</p>
                                <a href={paymobAppURL} target="_blank">Get Started<i className="fa fa-arrow-right"></i></a>
                            </div>
                    </div>
                </div>
            );
        }else{
            return (
                <div class="newStandalone">
                    <div className="invoice">
                        {this.state.is_orascom ?
                            <div className="orascom_header">
                                <img src={OrascomIMG} alt="Orascom" />
                            </div>
                        :
                            <>
                                <SimpleHeader/>
                                <div className="companyDetails">
                                    {this.state.userData.logo_uri ?
                                        <>
                                            <div className="compLogo">
                                                <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                            </div>
                                            <p> {this.state.userData.order_merchant_name}</p>
                                        </>
                                    :
                                    <h1>Paymob Invoice</h1>
                                    }
                                 </div>
                                </>
                        }
                        <div className="orderDetails">
                            <div className="orderImgDesc">
                                {/* <div className="orderImg">
                                    <img src={appConfig.getServerUrl() + this.state.userData.logo_uri}/>
                                </div> */}
                                <div className="orderNameDesc">
                                    <p className="productName">{this.state.userData.order_full_name != "N/A" && this.state.userData.order_full_name}</p>
                                    <p className="productDesc">{this.state.userData.order_name != "N/A" && this.state.userData.order_name}</p>
                                    <p className="productDesc">{this.state.userData.order_description && this.state.userData.order_description != "N/A" && this.state.userData.order_description}</p>
                                </div>
                            </div>
                            <div className="orderPrice">
                            <div className="priceItem">
                                    <p>
                                  Order ID
                                    </p>
                                    <span>
                                        {this.state.userData.order_id} 
                                    </span>
                                </div>
                                <div className="priceItem">
                                    <p>
                                    Item Price
                                    </p>
                                    <span>
                                    {this.state.userData.order_amount_egp + " " + this.state.userData.order_currency} 
                                    </span>
                                </div>
                      
                                {/* <div className="priceItem">
                                    <p>
                                    VAT (14%)
                                    </p>
                                    <span>
                                    {(this.state.userData.order_amount_egp*.14).toFixed(2) + " " + this.state.userData.order_currency}
                                    </span>
                                </div>
                                <div className="priceItem lastItem">
                                    <p>
                                    Total Payment
                                    </p>
                                    <span>
                                    {(this.state.userData.order_amount_egp+(this.state.userData.order_amount_egp*.14)+30).toFixed(2)}
                                    </span>
                                </div> */}
                            </div>
                        </div>
                        <div className="standaloneBody">
                            {this.state.userData.order_delivery?
                                <div>
                                    <CardHeader id="headingOne">
                                    <Button  className="collapseHeader" onClick={() => this.toggleAccordion(0)} aria-expanded={this.state.accordion[0]} aria-controls="collapseOne">
                                        <h5 className="">Personal Details</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[0]} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
                                    <CardBody>
                                        {this.renderDeliveryForm()}
                                    </CardBody>
                                    </Collapse>
                                    <CardHeader id="headingTwo">
                                    <Button  className="collapseHeader" aria-expanded={this.state.accordion[1]} aria-controls="collapseTwo">
                                        <h5 className="">Payment Method</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[1]} data-parent="#accordion" id="collapseTwo">
                                    <CardBody>
                                        <div className="paymentsMethodsNew">
                                            <div className="methods">
                                                <div id="choose_payment">
                                                    <h3>Choose your payment method</h3>
                                                    {this.paymentsMethods()}
                                                </div>
                                            </div>
                                            <div  id="payDiv">
                                                {this.state.accordion[1] && this.currentPaymentMethodComponent()}                          
                                            </div>  
                                        </div>
                                    </CardBody>
                                    </Collapse>
                                </div>
                            : this.state.completeSubDeliveryForm?
                                <div>
                                    <CardHeader id="headingOne">
                                    <Button  className="collapseHeader" onClick={() => this.toggleAccordion(0)} aria-expanded={this.state.accordion[0]} aria-controls="collapseOne">
                                        <h5 className="">Personal Details</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[0]} data-parent="#accordion" id="collapseOne" aria-labelledby="headingOne">
                                    <CardBody>
                                        {this.renderSubDeliveryForm()}
                                    </CardBody>
                                    </Collapse>
                                    <CardHeader id="headingTwo">
                                    <Button  className="collapseHeader" aria-expanded={this.state.accordion[1]} aria-controls="collapseTwo">
                                        <h5 className="">Payment Method</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={this.state.accordion[1]} data-parent="#accordion" id="collapseTwo">
                                    <CardBody>
                                        <div className="paymentsMethodsNew">
                                            <div className="methods">
                                                <div id="choose_payment">
                                                    <h3>Choose your payment method</h3>
                                                    {this.paymentsMethods()}
                                                </div>
                                            </div>
                                            <div  id="payDiv">
                                                {this.state.accordion[1] && this.currentPaymentMethodComponent()}                          
                                            </div>  
                                        </div>
                                    </CardBody>
                                    </Collapse>
                                </div>
                            :
                                <div>
                                    <CardHeader id="headingTwo">
                                    <Button  className="collapseHeader" aria-expanded={true} aria-controls="collapseTwo">
                                        <h5 className="">Payment Method</h5>
                                    </Button>
                                    </CardHeader>
                                    <Collapse isOpen={true} data-parent="#accordion" id="collapseTwo">
                                    <CardBody>
                                        <div className="paymentsMethodsNew">
                                            <div className="methods">
                                                <div id="choose_payment">
                                                    <h3>Choose your payment method</h3>
                                                    {this.paymentsMethods()}
                                                </div>
                                            </div>
                                            <div  id="payDiv">
                                                {this.currentPaymentMethodComponent()}                            
                                            </div>  
                                        </div>
                                    </CardBody>
                                    </Collapse>
                                </div>
                            }
                            

                            <div className="startSell">
                                <p>Start selling your products</p>
                                <a href={paymobAppURL} target="_blank">Get Started<i className="fa fa-arrow-right"></i></a>
                            </div>
                        </div>
                    </div>
                </div>   
            );
        }
    }
    render(){
        //let userData = JSON.parse(localStorage.userData);
        return (
            <div>
                {this.state.dataLoaded?this.renderBody():<Waiting height='100vh' />}
            </div>
        );
    }
    
}

export default invoice;
